<div class="container-fluid">
	<!-- Page Header with Utility Buttons -->
	<div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
		<h1 class="page-header mb-2 mb-lg-0">Package List</h1>

		<!-- Utility Buttons -->
		<div class="d-flex align-items-center" style="margin-top: 0.5rem;">
			<button *ngIf="_permissionsService.canAccess('packages_create')" mat-stroked-button color="primary"
				(click)="openEntityComponent(PackageEntityComponent, 'packages', 'package', 'create', null)"
				mat-button
				class="mb-1">
				Add Package
			</button>
		</div>
	</div>

	<nav mat-tab-nav-bar [tabPanel]="tabPanel">
		<a mat-tab-link *ngFor="let link of links"
			[routerLink]="link.linkRoute"
			[active]="link.retired === isRetired">
			{{link.linkTitle}}
		</a>
	</nav>

	<mat-tab-nav-panel #tabPanel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title>
					Filter
				</mat-panel-title>
				<mat-panel-description>
					<app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
				</mat-panel-description>
			</mat-expansion-panel-header>
			<form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">
				<div class="row">

					<div class="col-12 col-sm-6 col-lg">
						<mat-form-field class="full-width-field">
							<mat-label>Package Name</mat-label>
							<input
								matInput
								ngModel
								name="field_package_name_value"
								(ngModelChange)="onSubmit(f)"
								(selectionChange)="onSubmit(f)">
						</mat-form-field>
					</div>


					<div class="col-12 col-sm-6 col-lg">
						<mat-form-field class="full-width-field">
							<mat-label>SPS Code</mat-label>
							<mat-select (selectionChange)="onSubmit(f)" matInput ngModel name="field_sps_code_target_id">
								<mat-option [value]="''">None</mat-option>
								<mat-option *ngFor="let element of this._taxonomyService?.sps_code" [value]="element.name">
									{{ element.name }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>


					<!-- <div class="col-2">
						<mat-form-field class="full-width-field">
							<mat-label>Lesson Type</mat-label>
							<input
								matInput
								ngModel
								name="field_lesson_type_target_id"
								(blur)="onSubmit(f)"
								(selectionChange)="onSubmit(f)">
						</mat-form-field>
					</div> -->

					<div class="col-12 col-sm-6 col-lg">
						<mat-form-field class="full-width-field">
							<mat-label>Lesson Type</mat-label>
							<mat-select (selectionChange)="onSubmit(f)" matInput ngModel name="field_lesson_type_target_id_1">
								<mat-option [value]="''">None</mat-option>
								<mat-option *ngFor="let element of this._taxonomyService?.lesson_type" [value]="element.id">
									{{ element.name }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>

					<div class="col-12 col-sm-6 col-lg">
						<mat-form-field class="full-width-field">
							<mat-label>Lesson Price</mat-label>
							<input
								matInput
								ngModel
								name="field_lesson_price_value"
								(blur)="onSubmit(f)"
								(selectionChange)="onSubmit(f)">
						</mat-form-field>
					</div>


					<div class="col-12 col-sm-6 col-lg">
						<mat-form-field class="full-width-field">
							<mat-label>Lesson Count</mat-label>
							<input
								matInput
								ngModel
								name="field_lesson_count_value"
								(blur)="onSubmit(f)"
								(selectionChange)="onSubmit(f)">
						</mat-form-field>
					</div>


					<div class="col-12 col-sm-6 col-lg">
						<mat-form-field class="full-width-field">
							<mat-label>Total Price</mat-label>
							<input
								matInput
								ngModel
								name="field_total_price_value"
								(blur)="onSubmit(f)"
								(selectionChange)="onSubmit(f)">
						</mat-form-field>
					</div>


					<section class="section">

						<div class="float-end bring-inline">
							<button (click)="resetForm()" color="primary" mat-flat-button
								class="me-1" mat-button>Clear
								<!-- <mat-icon (click)="resetForm()" aria-hidden="false" aria-label="Menu dropdown" class=""></mat-icon> -->
							</button>
						</div>

					</section>


				</div>


				<section class="section">
				</section>

			</form>

		</mat-expansion-panel>

		<mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

		<div class="table-container">

			<div class="table-responsive-sticky table-responsive">

				<table mat-table #displayTable
					[dataSource]="dataSource"
					matSort
					(matSortChange)="sortDataView($event)"
					class="mt-4">

					<!-- id Column -->
					<ng-container matColumnDef="id">
						<th mat-header-cell *matHeaderCellDef
							sortActionDescription="Sort by id">
							ID
						</th>
						<td mat-cell *matCellDef="let element"> {{element.id}} </td>
					</ng-container>

					<!-- field_abbreviation Column -->
					<ng-container matColumnDef="field_abbreviation">
						<th mat-header-cell *matHeaderCellDef
							sortActionDescription="Sort by field_abbreviation">
							Abbreviation
						</th>
						<td mat-cell *matCellDef="let element"> {{element.field_abbreviation}} </td>
					</ng-container>

					<!-- field_lesson_count Column -->
					<ng-container matColumnDef="field_lesson_count_value_1">
						<th mat-header-cell *matHeaderCellDef
							mat-sort-header
							sortActionDescription="Sort by field_lesson_count">
							Lesson Count
						</th>
						<td mat-cell *matCellDef="let element"> {{ element.field_lesson_count }} </td>
					</ng-container>

					<!-- field_lesson_price Column -->
					<ng-container matColumnDef="field_lesson_price_value">
							<th mat-header-cell *matHeaderCellDef
								mat-sort-header
								sortActionDescription="Sort by field_lesson_price_value" class="text-end">
								Lesson Price
							</th>
							<td mat-cell *matCellDef="let element" class="text-end"> {{ element.field_lesson_price | studioCurrency }} </td>
						</ng-container>

						<!-- field_lesson_type Column -->
						<ng-container matColumnDef="field_lesson_type">
							<th mat-header-cell *matHeaderCellDef
								sortActionDescription="Sort by field_lesson_type">
								Lesson Type
							</th>
							<td mat-cell *matCellDef="let element"> {{ element.field_lesson_type }} </td>
						</ng-container>

												<!-- field_package_name Column -->
						<ng-container matColumnDef="field_package_name">
							<th mat-header-cell *matHeaderCellDef
								sortActionDescription="Sort by field_package_name">
								Name
							</th>
							<td mat-cell *matCellDef="let element">
								{{ element.field_package_name }}
								<mat-chip *ngIf="element.field_is_system_package === 'On'"
									class="ms-2"
									color="accent">
									System
								</mat-chip>
							</td>
						</ng-container>

						<!-- field_sps_code Column -->
						<ng-container matColumnDef="field_sps_code">
							<th mat-header-cell *matHeaderCellDef
								sortActionDescription="Sort by field_sps_code">
								SPS Code
							</th>
							<td mat-cell *matCellDef="let element"> {{ element.field_sps_code }} </td>
						</ng-container>

						<!-- field_total_price Column -->
						<ng-container matColumnDef="field_total_price_value">
							<th mat-header-cell *matHeaderCellDef
								mat-sort-header
								sortActionDescription="Sort by field_total_price" class="text-end">
								Total Price
							</th>
							<td mat-cell *matCellDef="let element" class="text-end"> {{ element.field_total_price | studioCurrency }} </td>
						</ng-container>

						<!-- field_custom_text Column -->
						<ng-container matColumnDef="field_custom_text">
							<th mat-header-cell *matHeaderCellDef
								sortActionDescription="Sort by field_custom_text">
								Actions
							</th>

																					<td mat-cell *matCellDef="let element">
								<button *ngIf="_permissionsService.canAccess('packages_edit')"
									mat-stroked-button
									PackageEntityComponent
									(click)="openEntityComponent(PackageEntityComponent, 'packages', 'package', 'edit', element.id)"
									mat-button>
										Edit
								</button>
								<!-- {{ element.id }} -->
								<!-- {{ element.field_custom_text }}  -->
							</td>
						</ng-container>


					<!-- Footer for pagination -->
					<ng-container matColumnDef="pagination-footer">
						<td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
							<mat-paginator
								[disabled]="ShowProgressBar"
								(page)="pageChanged($event)"
								[pageSizeOptions]="onPageSizeOptions()"
								[length]="30"
								[pageSize]="paginationTotalPages"
								[pageIndex]="paginationIndex"
								aria-label="Select page of view"></mat-paginator>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
					<tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></tr>
					<tr mat-footer-row *matFooterRowDef="['pagination-footer']; sticky: true"></tr>
				</table>

			</div>

		</div>


	</mat-tab-nav-panel>
</div>
